import axios from 'axios'

import auth from '../auth'
import productRegister from './productRegister'
import users from './users'

const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? 'https://reg-api.idha.com' : 'http://localhost:5000'
})

api.interceptors.request.use((cfg) => {
  // Insert access token in each request
  cfg.headers.Authorization = `Bearer ${auth.getAccessToken()}`
  return cfg
})

export default {
  productRegister: productRegister(api),
  users: users(api)
}
